  import React,{ useState, useEffect, useRef } from 'react';
  import { downloadCsv } from '../common/sharedFunctions';
  import MaterialTable from "material-table";
  import { useSelector, useDispatch } from "react-redux";
  import CircularLoading from "../components/CircularLoading";
  import { api } from 'common';
  import { useTranslation } from "react-i18next";
  import moment from 'moment/min/moment-with-locales';
  import {colors} from '../components/Theme/WebTheme';
  import {Typography,Switch} from '@mui/material';
import AlertDialog from '../components/AlertDialog';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import BlankTable from '../components/BlankTable';


  export default function Users() {
    const { t,i18n } = useTranslation();
    const isRTL = i18n.dir();
    const {
      editUser,
      fetchUsersOnce,
      revokeUserTokens,
      deleteUsersAllcars,
      removeChatWithUserDelete
    } = api;
    const settings = useSelector(state => state.settingsdata.settings);
    const [data, setData] = useState([]);
    const staticusers = useSelector(state => state.usersdata.staticusers);
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const loaded = useRef(false);
    const navigate = useNavigate();
    const {id} = useParams()
    const {state} = useLocation();



    useEffect(()=>{
      dispatch(fetchUsersOnce());
    },[dispatch,fetchUsersOnce]);
    
    useEffect(()=>{
      if(staticusers){
        setData(staticusers.filter(user => user.usertype ==='customer' && ((user.fleetadmin === auth.profile.uid && auth.profile.usertype === 'fleetadmin')|| auth.profile.usertype === 'subadmin'|| auth.profile.usertype === 'admin')).map(user => ({...user})));
      }else{
        setData([]);
      }
      loaded.current = true;
    },[staticusers,auth.profile]);

    const columns = [
      { title: t('createdAt'), field: 'createdAt', editable: 'never', defaultSort: 'desc', render: rowData => rowData.createdAt ? moment(rowData.createdAt).format('lll') : null, },
    { title: t('first_name'), field: 'firstName', },
    { title: t('last_name'), field: 'lastName', },
    { title: t('mobile'), field: 'mobile', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo", },
    { title: t('email'), field: 'email', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo", headerStyle: { textAlign: 'center' } },
    { title: t('profile_image'), field: 'profile_image', render: rowData => rowData.profile_image ? <img alt='Profile' src={rowData.profile_image} style={{ width: 50, borderRadius: '50%' }} /> : <AccountCircleIcon sx={{ fontSize: 50 }} />, editable: 'never', },
    {
      title: t('account_approve'), field: 'approved', type: 'boolean', render: (rowData) => (
        <Switch
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
          disabled={!settings.AllowCriticalEditsAdmin}
        />
      ),
    },
    ];

    const [selectedRow, setSelectedRow] = useState(null);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

    const handelApproved = (rowData) => {
      const updatedUser = { ...rowData, approved: !rowData.approved };
  
      dispatch(editUser(updatedUser.id, updatedUser));
      dispatch(fetchUsersOnce());
      return updatedUser;
    };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const [currentPage, setCurrentPage] = useState(0); 

  useEffect(()=>{
   setCurrentPage(state?.pageNo)
  },[state])


const handlePaginationChange = (page) => {
  setCurrentPage(page)
};

const options={
  initialPage:state?.pageNo ||0,
  pageSize: 10,
  pageSizeOptions: [10, 15, 20],
  exportCsv: (columns, data) => {
    let hArray = [];
    const headerRow = columns.map(col => {
      if (typeof col.title === 'object') {
        return col.title.props.text;
      }
      hArray.push(col.field);
      return col.title;
    });
    const dataRows = data.map(({ tableData, ...row }) => {
      row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
      let dArr = [];
      for(let i=0;i< hArray.length; i++) {
        dArr.push(row[hArray[i]]);
      }
      return Object.values(dArr);
    })
    const { exportDelimiter } = ",";
    const delimiter = exportDelimiter ? exportDelimiter : ",";
    const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
    const csvFileName = 'download.csv';
    downloadCsv(csvContent, csvFileName);
  },
  exportButton: {
    csv: settings.AllowCriticalEditsAdmin,
    pdf: false,
  },
  maxColumnSort: "all_columns",
  rowStyle: rowData => ({
    backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
  }),
  editable:{
    backgroundColor: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: 'Lucida Console", "Courier New", monospace'
  },
  headerStyle: {
    position: "sticky",
    top: "0px",
    backgroundColor: colors.SECONDARY,
    color: colors.WHITE,
    textAlign: "center",
    fontSize: "0.8em",
    fontWeight: "bold ",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    border: "1px solid rgba(224, 224, 224, 1)",
  },
  cellStyle: {
    border: "1px solid rgba(224, 224, 224, 1)",
    textAlign: "center",
  },
  actionsColumnIndex: -1,
}

const  localization={ body:{
  addTooltip: (t('add')),
  deleteTooltip: (t('delete')),
  editTooltip: (t('edit')),
  emptyDataSourceMessage: (
    (t('blank_message'))
),
  editRow: { 
    deleteText: (t('delete_message')),
    cancelTooltip: (t('cancel')),
    saveTooltip: (t('save')) 
    }, 
  },
  toolbar: {
    searchPlaceholder: (t('search')),
    exportTitle: (t('export')),
  },
  header: {
    actions: (t('actions')) 
},
pagination: {
  labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
  firstTooltip: (t('first_page_tooltip')),
  previousTooltip: (t('previous_page_tooltip')),
  nextTooltip: (t('next_page_tooltip')),
  lastTooltip: (t('last_page_tooltip'))
},
}
    return (
      !loaded.current? <CircularLoading/>:
      <div>
         {data && data.length > 0 ? 
        <MaterialTable
          title={t('riders')}
          onChangePage={(page) => handlePaginationChange(page)}
          columns={columns}
          style={{direction:isRTL ==='rtl'?'rtl':'ltr',  borderRadius: "8px", boxShadow: `4px 4px 6px ${colors.THIRDCOLOR}`}}
          data={data}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={options}
          localization={localization}
          editable={{
            onRowDelete: async (oldData) => {
              try{
                if (settings.AllowCriticalEditsAdmin) {
                  await revokeUserTokens(oldData.id);
                  await deleteUsersAllcars(oldData.id);
                  await removeChatWithUserDelete(oldData.id);
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      dispatch(fetchUsersOnce());
                      resolve();
                    }, 600);
                  });
                } else {
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      setCommonAlert({ open: true, msg: t('demo_mode') });
                      resolve();
                    }, 600);
                  });
                }
              }catch(error){
                console.log("error in deletion", error);
              }
            },
          }}
          
          actions={[
            {
              icon: "add",
              tooltip: t("add_customer"),
              isFreeAction: true,
              onClick: (event) => navigate( '/users/addrider',  { state: { pageNo: currentPage }} )
            },
            {
              icon: "info",
              tooltip: t("profile_page_subtitle"),
              onClick: (event, rowData) => {
              navigate( `/users/customerdetails/${rowData.id}`,  { state: { pageNo: currentPage }} )

              },
            },

            (rowData) => {
              const driverUser = staticusers && staticusers.find(u => u.usertype === 'driver' && (
                (rowData.email && u.email && u.email.toLowerCase() === rowData.email.toLowerCase()) ||
                (rowData.mobile && u.mobile && u.mobile === rowData.mobile) ||
                (rowData.id && u.id === rowData.id) ||
                (rowData.driverAccountId && u.id === rowData.driverAccountId)
              ));
              const hasDriverDocs = Boolean(
                rowData.licenseImage || 
                rowData.licenseImageBack || 
                rowData.verifyIdImage || 
                rowData.verifyIdImageBack || 
                rowData.photoWithLicense || 
                rowData.policeClearance
              );
              const targetDocUserId = driverUser ? driverUser.id : (hasDriverDocs ? rowData.id : null);

              return {
                icon: () => (
                  <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", padding: 10, backgroundColor: colors.MAIN_COLOR, color: colors.WHITE, borderRadius: 5, boxShadow: "0px 3px 5px 0px #B4B4B3" }}>

                    <Typography style={{ color: colors.LandingPage_Background }}>
                      {t("documents")}
                    </Typography>
                  </div>
                ),
                tooltip: t('documents'),
                hidden: !targetDocUserId,
                onClick: () => targetDocUserId && navigate( `/users/userdocuments/${id}/${targetDocUserId}`,  { state: { pageNo: currentPage }} )
              };
            },

          ]}
        />
        :<BlankTable 
        title={t('riders')} 
         columns={columns}  
         data={[]}  
         style={{direction:isRTL ==='rtl'?'rtl':'ltr',  borderRadius: "8px", boxShadow: `4px 4px 6px ${colors.THIRDCOLOR}`}}
         options={options}
         localization={localization}
          actions={[
            {
              icon: "add",
              tooltip: t("add_customer"),
              isFreeAction: true,
              onClick: (event) => navigate( '/users/addrider',  { state: { pageNo: currentPage }} )
            },
    
          ]}
          />
          }

      
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
    );
  }
